"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updationQuery = exports.errorQuery = exports.resolvedQueryById = exports.resolvedQuery = void 0;
const core_1 = require("@apollo/client/core");
//sample for query
exports.resolvedQuery = {
    name: 'allUsers',
    query: (0, core_1.gql) `
    query {
      allUsers {
        id
        name
        email
        address
      }
    }
  `,
};
//sample for queryBy parameters
exports.resolvedQueryById = {
    name: 'user',
    query: (0, core_1.gql) `
    query ($id: Int!) {
      user(id: $id) {
        id
        name
        email
        address
      }
    }
  `,
};
//case for error testing
exports.errorQuery = {
    name: 'getDat',
    query: (0, core_1.gql) `
    query {
      getDat {
        value
      }
    }
  `,
};
//sample for update by parameters
exports.updationQuery = {
    name: 'updateUser',
    mutate: (0, core_1.gql) `
    mutation ($id: Int!, $name: String) {
      updateUser(id: $id, name: $name) {
        id
        name
      }
    }
  `,
};
//# sourceMappingURL=generic.queries.js.map